import { useCallback } from 'react';

import qs from 'qs';
import { useLocation } from 'react-router';

import { useTracking } from '@change-corgi/core/react/tracking';

import type { ImpactPageData } from 'src/app/pages/about/impact/pageContext';
import { useImpactPageData } from 'src/app/pages/about/impact/pageContext';

type Result = ModelHookResult<
	{
		trendingPetitions: ImpactPageData['suggestedPetitions'];
		sapCtaUrl: string;
	},
	{ trackSapClick: () => void }
>;

export function useTrendingPetitions(): Result {
	const {
		data: { suggestedPetitions },
	} = useImpactPageData();
	const track = useTracking();
	const location = useLocation();

	const sapCtaUrl = `/start-a-petition/intro${qs.stringify(
		{
			source_location: 'impact',
			...qs.parse(location.search, { ignoreQueryPrefix: true }),
		},
		{ addQueryPrefix: true },
	)}`;

	const handleSapClick = useCallback(() => {
		void track('sap_impact_page_click');
	}, [track]);

	return {
		data: { trendingPetitions: suggestedPetitions, sapCtaUrl },
		actions: { trackSapClick: handleSapClick },
	};
}
